import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stumbleupon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.9 266V335.7C502.9 397.8 452.6 448.1 390.5 448.1 328.7 448.1 278.1 398.3 278.1 336.8V266.6L312.4 282.6 363.5 267.4V338C363.5 352.7 375.5 364.5 390.2 364.5S417 352.7 417 338V266H502.9zM278.2 207.8L312.5 223.8 363.6 208.6V173C363.6 112.5 312.5 64 251.5 64 190.7 64 139.4 112.2 139.4 172.2V334.6C139.4 349.5 127.4 361.3 112.7 361.3S86 349.5 86 334.6V266H0V335.7C0 397.7 50.3 448 112.4 448 174 448 224.8 398.5 224.8 337.2V176.9C224.8 162.2 236.8 150.2 251.5 150.2S278.2 162.2 278.2 176.9V207.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stumbleupon.js
// module id = Fg87
// module chunks = 144